import { ADF } from "@atlassiansox/bxp-content-framework";

import {
    mock$AssetModel,
    mockUiImageModel,
    mockUiImageModelContent,
    mockUiLinkModel,
    mockUiLinkModelContent,
    mockUiTooltipModel,
    mockUiTooltipModelContent
} from ".";

export function mockAdfDocument({
    version = 1,
    type = "doc",
    content = []
}: Partial<ADF.Document> = {}): ADF.Document {
    return {
        version,
        type,
        content
    };
}

export function mockAdfText({
    type = "text",
    text = "The way to get started is to quit talking and begin doing.",
    ...optionals
}: Partial<ADF.Text> = {}): ADF.Text {
    return {
        type,
        text,
        ...optionals
    };
}

export function mockAdfHeading({
    type = "heading",
    attrs = {
        level: 1
    },
    ...optionals
}: Partial<ADF.Heading> = {}): ADF.Heading {
    return {
        type,
        attrs,
        ...optionals
    };
}

export function mockAdfParagraph({
    type = "paragraph",
    content = [mockAdfText()]
}: Partial<ADF.Paragraph> = {}): ADF.Paragraph {
    return {
        type,
        content
    };
}

export function mockAdfBlockquote({
    type = "blockquote",
    content = [mockAdfParagraph()]
}: Partial<ADF.Blockquote> = {}): ADF.Blockquote {
    return {
        type,
        content
    };
}

export function mockAdfRule({
    type = "rule"
}: Partial<ADF.Rule> = {}): ADF.Rule {
    return {
        type
    };
}

export function mockAdfListItem({
    type = "listItem",
    content = [mockAdfParagraph()]
}: Partial<ADF.ListItem> = {}): ADF.ListItem {
    return {
        type,
        content
    };
}

export function mockAdfOrderedList({
    type = "orderedList",
    content = [mockAdfListItem(), mockAdfListItem(), mockAdfListItem()]
}: Partial<ADF.OrderedList> = {}): ADF.OrderedList {
    return {
        type,
        content
    };
}

export function mockAdfBulletList({
    type = "bulletList",
    content = [mockAdfListItem(), mockAdfListItem(), mockAdfListItem()]
}: Partial<ADF.BulletList> = {}): ADF.BulletList {
    return {
        type,
        content
    };
}

export function mockAdfLink({
    type = "link",
    attrs = {
        href: "/foobar"
    },
    ...optionals
}: Partial<ADF.LinkMark> = {}): ADF.LinkMark {
    return {
        type,
        attrs,
        ...optionals
    };
}

export function mockAdfCode({
    type = "code"
}: Partial<ADF.CodeMark> = {}): ADF.CodeMark {
    return {
        type
    };
}

export function mockAdfStrong({
    type = "strong"
}: Partial<ADF.StrongMark> = {}): ADF.StrongMark {
    return {
        type
    };
}

export function mockAdfEm({
    type = "em"
}: Partial<ADF.EmMark> = {}): ADF.EmMark {
    return {
        type
    };
}

export function mockAdfUnderline({
    type = "underline"
}: Partial<ADF.UnderlineMark> = {}): ADF.UnderlineMark {
    return {
        type
    };
}

export function mockAdfEmbeddedUiImage({
    type = "bxpEmbeddedViewBlock",
    model = mockUiImageModel({
        content: mockUiImageModelContent({
            image: mock$AssetModel({
                title: "Engineering Playbook",
                url: "/ui-modal/playbooks_boardtile_engineering.png",
                width: 1414,
                height: 712
            })
        })
    })
}: Partial<ADF.EmbeddedViewBlock> = {}): ADF.EmbeddedViewBlock {
    return {
        type,
        model
    };
}

export function mockAdfEmbeddedUiLink({
    type = "bxpEmbeddedViewInline",
    model = mockUiLinkModel({
        content: mockUiLinkModelContent({
            url: "#test",
            text: "Learn more"
        })
    })
}: Partial<ADF.EmbeddedViewInline> = {}): ADF.EmbeddedViewInline {
    return {
        type,
        model
    };
}

export function mockAdfEmbeddedUiTooltip({
    type = "bxpEmbeddedViewInline",
    model = mockUiTooltipModel({
        content: mockUiTooltipModelContent({
            triggerText: "Tooltip",
            tooltipText: mockAdfDocument({ content: [mockAdfText()] })
        })
    })
}: Partial<ADF.EmbeddedViewInline> = {}): ADF.EmbeddedViewInline {
    return {
        type,
        model
    };
}

export function mockAdfTextWithLineBreaks({
    type = "text",
    text = "The way to get started is\n to quit talking and\n begin doing.",
    ...optionals
}: Partial<ADF.Text> = {}): ADF.Text {
    return {
        type,
        text,
        ...optionals
    };
}
